// Authentication views
import Authentication from "../layout/index.vue";
import Login from "../views/Login.vue";
import LoginResetPassword from "../views/ResetPassword.vue";
import ForgottenPassword from "../views/ForgottenPassword.vue";
import UserInvite from "../views/UserInvite.vue";
import UserBecome from "../views/UserBecome.vue";

export const authentication = [
	{
		path: "/login",
		component: Authentication,
		// noAuth means you don't have to be logged in.
		meta: {
			noAuth: true
		},
		children: [
			{
				path: "",
				name: "Login",
				component: Login
			},
			{
				path: "/forgotten-password",
				name: "ForgottenPassword",
				component: ForgottenPassword,
				meta: {
					noAuth: true
				}
			},
			{
				path: "/setpassword/:userid/:resettoken",
				name: "SetPassword",
				component: LoginResetPassword,
				// noAuth means you don't have to be logged in.
				meta: {
					noAuth: true
				}
			},
			{
				path: "/invite/:userid/:resettoken",
				name: "UserInvite",
				component: UserInvite,
				// noAuth means you don't have to be logged in.
				meta: {
					noAuth: true
				}
			}
		]
	},
	{
		path: "/become/:token/:become?",
		name: "UserBecome",
		component: UserBecome,
		// noAuth means you don't have to be logged in.
		meta: {
			noAuth: true
		}
	}
];

export const Routes = authentication;
